import { render, staticRenderFns } from "./RandomMember.vue?vue&type=template&id=2365d8ae&scoped=true&"
import script from "./RandomMember.vue?vue&type=script&lang=ts&"
export * from "./RandomMember.vue?vue&type=script&lang=ts&"
import style0 from "./RandomMember.vue?vue&type=style&index=0&id=2365d8ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2365d8ae",
  null
  
)

export default component.exports